import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/GasCheckoutDataProvider";
import Checkbox from "../../../../../shared/forms/Checkbox";
import DifferentAccountHolder from "../DifferentAccountHolder";

const RemittancePayment = () => {
    const dataContext = useContext(DataContext);
    const { paymentData } = dataContext.data;
    const { setPaymentData, clearFormErrorWithStartField } =
        dataContext.actions;

    /**
     * When the payment type changes.
     *
     * @param {*} value
     */

    const handleInvoiceCheckboxChange = () => {
        setPaymentData({
            ...paymentData,
            ...{
                payment_different_account_holder:
                    !paymentData.payment_different_account_holder,
            },
        });
        clearFormErrorWithStartField("payment");
    };

    return (
        <section>
            {
                <React.Fragment>
                    <Checkbox
                        checked={paymentData.payment_different_account_holder}
                        onClick={handleInvoiceCheckboxChange}
                        label="Abweichender Kontoinhaber"
                    />
                    {paymentData.payment_different_account_holder === true && (
                        <DifferentAccountHolder />
                    )}
                </React.Fragment>
            }
        </section>
    );
};

export default RemittancePayment;
